import React from 'react';
import { colors } from '@styleseat/brand';

type TimeCalendarDatesIconProps = {
  width?: number;
  height?: number;
  topFillColor?: string;
  bottomFillColor?: string;
  /** @deprecated use color */
  outlineColor?: string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const TimeCalendarDatesIcon: React.FC<TimeCalendarDatesIconProps> = ({
  width = 24,
  height = 24,
  topFillColor = 'none',
  bottomFillColor = 'none',
  outlineColor = colors.blackInBlack,
  color,
}: TimeCalendarDatesIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>TimeCalendarDatesIcon</title>
    <rect
      x="7.1665"
      y="8.33325"
      width="26.6667"
      height="5"
      fill={topFillColor}
    />
    <rect
      x="7.1665"
      y="16.6667"
      width="26.6667"
      height="16.6667"
      fill={bottomFillColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8335 9.99992H10.5002V8.33325H7.16683V13.3333H33.8335V8.33325H30.5002V9.99992H27.1668V8.33325H13.8335V9.99992ZM33.8335 16.6666H7.16683V33.3333H33.8335V16.6666ZM27.1668 4.99992H13.8335V3.33325H10.5002V4.99992H7.16683C5.32588 4.99992 3.8335 6.4923 3.8335 8.33325V33.3333C3.8335 35.1742 5.32588 36.6666 7.16683 36.6666H33.8335C35.6744 36.6666 37.1668 35.1742 37.1668 33.3333V8.33325C37.1668 6.4923 35.6744 4.99992 33.8335 4.99992H30.5002V3.33325H27.1668V4.99992ZM15.5002 23.3333H12.1668V19.9999H15.5002V23.3333ZM18.8335 23.3333H22.1668V19.9999H18.8335V23.3333ZM28.8335 23.3333H25.5002V19.9999H28.8335V23.3333ZM12.1668 29.9999H15.5002V26.6666H12.1668V29.9999ZM22.1668 29.9999H18.8335V26.6666H22.1668V29.9999Z"
      fill={color || outlineColor}
    />
  </svg>

);

export default TimeCalendarDatesIcon;
